import { ApolloLink } from '@apollo/client/core';

const HEADER_LOCATION = 'Cf-Ipcountry';

export const responseHeadersLink = new ApolloLink((operation, forward) => {
  return forward(operation).map((response) => {
    // Access the context from the response
    const context = operation.getContext();
    const headers = context.response?.headers;

    if (headers) {
      const locationHeader = headers.get(HEADER_LOCATION);
      // VpnDetector.check(locationHeader); // TODO: implement VpnDetector if needed
    }

    return response;
  });
});
